<template>
    <div class="cardBuy ">
        <!--购买页面-->
        <div class="selectBuy delFloat padding-small border margin-medium-top position-relative commonBackground">
            <div class="float-left margin-top pictureImg rounded-medium">
                <img v-lazy="productData.coverImg" width="330" class="rounded-medium" height="216" :key="imgSrc" src=""
                     alt="">
            </div>
            <div class="float-left  rightTopBox">
                <h3>{{productData.title}}</h3>
                <div class="margin-bottom"><span class="text-m-size">价格：</span> <span class="  money">{{'￥'+productData.salePrice}}</span>
                </div>
                <div class="margin-bottom"><span class="text-m-size">有效期：</span>{{productData.expireTime}}</div>
                <div class="margin-bottom"><span class="text-m-size">类型：</span>
                    <el-button size="small"
                               v-for="(item,index) in productList"
                               @click="selectCard(item.name)"
                               :key="index" :class="productData.name===item.name?'cardActive':''">
                        {{item.name}}
                    </el-button>
                </div>

            </div>
            <div class="text-right position-absolute buyBtn">
                <el-button size="medium" class="cardBuyBtn" @click="cardBuyInto">立即购买</el-button>
            </div>
            <div class="float-right">
                <el-button type="text" class="text-default-color">
                    <a class="changeBlueColor" href="http://wpa.qq.com/msgrd?v=3&uin=3088290939&site=qq&menu=yes">
                        <span style="font-size:1.1em;" class=" iconfont icon-xingzhuang">
                            <span class="text-default-color"> 联系客服</span>
                        </span>
                    </a>
                </el-button>
            </div>
        </div>


        <div class="selectBuy delFloat padding-small border margin-medium-top position-relative commonBackground">
            <div class="pd_floor">
                <div class="ui-title">购买须知 </div>
                <div style="line-height: 30px" ><p v-html="purchaseNotes">{{purchaseNotes}}</p></div>
            </div>

            <div class="pd_floor">
                <div class="ui-title">高招教育网简介 </div>
                <div  style="line-height: 30px" ><p v-html="description">{{description}}</p></div>
            </div>


            <div class="pd_floor">
                <div class="ui-title">会员权限说明 </div>
                <div  style="line-height: 30px" ><p v-html="authDescription">{{authDescription}}</p></div>
            </div>
        </div>


    </div>
</template>
<script>
    import {cardBuyIndex, cardBuyOrderPerson} from "../../../config";
    import {getSessionStore, setSessionStore} from "../../../assets/static/global/global";
    import cookies from 'js-cookie'

    export default {
        name: "cardBuy",
        data() {
            return {
                //图片地址
                imgSrc: 'http://s.oasisedu.net/newLZPC/560.00.c66d68a7.png',
                productList: [],
                productData: '',
                authDescription: '', //权限描述
                description: '', //产品简介
                purchaseNotes: '', //注意事项
            }
        },
        mounted() {
            this.cardBuyInfo();
        },
        methods: {
            //选择卡片
            selectCard(val) {
                let zhi = this.productList.filter((valSmall) => {
                    return val === valSmall.name;
                })
                this.productData = zhi[0];
            },
            //获取卡片购买的基本信息
            async cardBuyInfo() {
                let result = await cardBuyIndex();
                if (result.status) {
                    console.log('我是购卡的基本信息');
                    console.log(result.data);
                    this.productList = result.data.productList;
                    this.productData = result.data.productList[0];
                    this.authDescription = result.data.authDescription;
                    this.description = result.data.description;
                    this.purchaseNotes = result.data.purchaseNotes;
                } else {

                }
            },
            //点击购买按钮
            async cardBuyInto() {
                console.log(cookies.get('userInfo'));
                if (cookies.get('userInfo')) {
                    this.$router.push({path: '/login/cardPay', query: {productId: this.productData.productId}});
                } else {
                    this.$router.push('/login');
                    setSessionStore('abnormalRouting', '/login/cardBuy');
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .cardBuy {
        width: 1000px;
        margin: 0 auto;

        .cardActive {
            border: 1px solid #1A83FF;
            color: #1A83FF !important;
        }

        .buyBtn {
            right: 80px;
            bottom: 20px;
        }

        .cardBuyBtn {
            background: #00a4ef;
            color: #ffffff;
            border: 1px solid lightseagreen;
        }

        .selectBuy {
            .pictureImg {

            }

            .rightTopBox {
                margin-left: 50px;

                .money {
                    color: orangered;
                    font-size: 1.8em;
                    font-weight: 600;
                }

            }

            .float-right {
                margin-right: 50px;
            }
        }

        .pd_floor {
            padding: 20px 0;
            border-bottom: 1px solid #e3e3e3;
        }

        .ui-title {
            font-size: 16px;
            font-weight: 700;
            padding-left: 10px;
            border-left: 4px solid #0d67af;
            margin-bottom: 7px;
        }
    }

</style>
